import React from "react";
import "./../Workspace2/sidebar.css";
import logov2 from "../../assets/signin.png";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useHistory } from "react-router";
import { getWorkspace } from "../Components/ApiServices/apiHandler";
import { useState } from "react";
import { useEffect } from "react";
// import CheckIcon from "@mui/icons-material/Check";

import commoncss from "../../myfin_v2/css/common.module.css"
import wsCreationcss from '../../myfin_v2/css/workspaceCreation.module.css'
import standalonePgbarcss from '../../myfin_v2/css/standaloneProgressBar.module.css'

import { ReactComponent as CheckIcon } from '../../myfin_v2/assets/icons/whiteCheck.svg'

const StandaloneProgressBar = ({
  ActiveStage,
  setActiveStage,
}) => {

  var outerBadge1 = `${standalonePgbarcss.numBadge} ${standalonePgbarcss.inactiveBadgeBgClr} ${standalonePgbarcss.badge}`
  var innerBadge1 = `${standalonePgbarcss.numBadgeInner} ${standalonePgbarcss.innerBadgeBgClr}`
  var badgeConnecter1 = `${standalonePgbarcss.numbConnterStart2} ${standalonePgbarcss.inactiveBadgeBgClr}`
  var content1 = 1

  var outerBadge2 = `${standalonePgbarcss.numBadge} ${standalonePgbarcss.inactiveBadgeBgClr} ${standalonePgbarcss.badge}`
  var innerBadge2 = `${standalonePgbarcss.numBadgeInner} ${standalonePgbarcss.innerBadgeBgClr}`
  var badgeConnecter2 = `${standalonePgbarcss.numbConnterStart2} ${standalonePgbarcss.inactiveBadgeBgClr}`
  var content2 = 2

  var outerBadge3 = `${standalonePgbarcss.numBadge} ${standalonePgbarcss.inactiveBadgeBgClr} ${standalonePgbarcss.badge}`
  var innerBadge3 = `${standalonePgbarcss.numBadgeInner} ${standalonePgbarcss.innerBadgeBgClr}`
  var badgeConnecter3 = `${standalonePgbarcss.numbConnterStart3} ${standalonePgbarcss.inactiveBadgeBgClr}`
  var content3 = 3

  if (ActiveStage === 1) {
    outerBadge1 = `${standalonePgbarcss.numBadge} ${standalonePgbarcss.activeBadegClr} ${standalonePgbarcss.badge}`;
    innerBadge1 = `${standalonePgbarcss.numBadgeInner} ${standalonePgbarcss.innerBadgeBgClr} ${ActiveStage === 1? standalonePgbarcss.numBadgeInnerActive:''}`
    badgeConnecter1 = `${standalonePgbarcss.numbConnterStart1} ${standalonePgbarcss.activeBadgeBgClr}`
    content1 = 1
  }
  else if (ActiveStage === 2) {
    outerBadge1 = `${standalonePgbarcss.numBadge} ${standalonePgbarcss.completeBadgeClr} ${standalonePgbarcss.badge}`;
    innerBadge1 = `${standalonePgbarcss.numBadgeInner} ${standalonePgbarcss.completeBadgeClr}`
    badgeConnecter1 = `${standalonePgbarcss.numbConnterStart1} ${standalonePgbarcss.completedBadgConnecterClr}`
    content1 = <CheckIcon />

    outerBadge2 = `${standalonePgbarcss.numBadge} ${standalonePgbarcss.activeBadegClr} ${standalonePgbarcss.badge}`
    innerBadge2 = `${standalonePgbarcss.numBadgeInner} ${standalonePgbarcss.innerBadgeBgClr} ${ActiveStage === 2? standalonePgbarcss.numBadgeInnerActive:''}`
    badgeConnecter2 = `${standalonePgbarcss.numbConnterStart3} ${standalonePgbarcss.lastConnecter} `

    // badgeConnecter3 = `${standalonePgbarcss.numbConnterStart3} ${standalonePgbarcss.lastInActiverBar} `
  }
  else if (ActiveStage === 3) {
    outerBadge1 = `${standalonePgbarcss.numBadge} ${standalonePgbarcss.completeBadgeClr} ${standalonePgbarcss.badge}`;
    innerBadge1 = `${standalonePgbarcss.numBadgeInner} ${standalonePgbarcss.completeBadgeClr}`
    badgeConnecter1 = `${standalonePgbarcss.numbConnterStart1} ${standalonePgbarcss.fullCompletedBadgConnecterClr} `
    content1 = <CheckIcon />

    outerBadge2 = `${standalonePgbarcss.numBadge} ${standalonePgbarcss.completeBadgeClr} ${standalonePgbarcss.badge}`
    innerBadge2 = `${standalonePgbarcss.numBadgeInner} ${standalonePgbarcss.completeBadgeClr}`
    badgeConnecter2 = `${standalonePgbarcss.numbConnterStart2} ${standalonePgbarcss.fullCompletedBadgConnecterClr} `
    content2 = <CheckIcon />

    outerBadge3 = `${standalonePgbarcss.numBadge} ${standalonePgbarcss.activeBadegClr} ${standalonePgbarcss.badge}`
    innerBadge3 = `${standalonePgbarcss.numBadgeInner} ${standalonePgbarcss.innerBadgeBgClr} ${ActiveStage === 3? standalonePgbarcss.numBadgeInnerActive:''}`
    badgeConnecter3 = `${standalonePgbarcss.numbConnterStart3} ${standalonePgbarcss.lastConnecter} `
  }

  return (

    <div className={standalonePgbarcss.numBadgeMainContainer}>
      <div className={standalonePgbarcss.numberContainer}  style={{ marginTop: "20px" }}>
        <div onClick={() => { }} key={1} className={`${standalonePgbarcss.numBadgeContainer} ${standalonePgbarcss.badgeContainerOne}`}>
          <div className={badgeConnecter1}></div>
          <div className={`${outerBadge1} ${standalonePgbarcss.badge}`} >
            <div className={innerBadge1}>{content1}</div>
          </div>
          <div className={`${standalonePgbarcss.numberText} ${standalonePgbarcss.numberText1}`}>PROJECT CREATION</div>
        </div>
        <div onClick={() => { }} key={2} className={`${standalonePgbarcss.numBadgeContainer} ${standalonePgbarcss.badgeContainerThree}`}>
          <div className={badgeConnecter2}></div>
          <div className={`${outerBadge2} ${standalonePgbarcss.badge}`}>
            <div className={innerBadge2}>{content2}</div>
          </div>
          <div className={`${standalonePgbarcss.numberText} ${standalonePgbarcss.numberText3}`}>FILE UPLOAD</div>
        </div>
        {/* <div onClick={() => { }} key={3} className={`${standalonePgbarcss.numBadgeContainer} ${standalonePgbarcss.badgeContainerThree}`}>
          <div className={badgeConnecter3}></div>
          <div className={`${outerBadge3} ${standalonePgbarcss.badge}`}>
            <div className={innerBadge3}>{content3}</div>
          </div>
          <div className={`${standalonePgbarcss.numberText} ${standalonePgbarcss.numberText3}`}>DATA MAPPING</div>
        </div> */}
      </div>
    </div>
  );
};

export default StandaloneProgressBar;
